const MAX = 500;
const buf = [];
const listeners = new Set();

export function logPush(entry) {
  buf.push({ ts: new Date().toISOString(), ...entry });
  if (buf.length > MAX) buf.shift();
  for (const fn of listeners) fn(entry);
  // also mirror to console for dev
  const { level='error', message='', stack, meta } = entry;
  const consoleMethod = console[level] || console.error;
  consoleMethod(
    '[APP]', message, meta || '', stack || ''
  );
}

export function logAll() { return [...buf]; }
export function onLog(fn) { listeners.add(fn); return () => listeners.delete(fn); }
export function clearLogs() { buf.length = 0; }

export function serializeLogs(format='text') {
  const logs = logAll();
  if (format === 'json') return JSON.stringify(logs, null, 2);
  return logs.map(l => `[${l.ts}] ${l.level?.toUpperCase?.()||'ERROR'}: ${l.message}${l.stack?`\n${l.stack}`:''}${l.meta?`\nMETA: ${JSON.stringify(l.meta)}`:''}`).join('\n\n');
}